import type { AssetsLinkRepository } from '#/domain/assetsLink/AssetsLinkRepository'
import type { AssetsLink } from '#/domain/assetsLink/AssetsLink'
import type { HttpClientPort } from '#/infrastructure/persistence/HttpClientPort'
import { toDomain, type AssetsLinkResponseDto } from './AssetsLinkDto'

export class HttpAssetsLinkRepository implements AssetsLinkRepository {
  constructor(private readonly http: HttpClientPort) {}

  async create(assetsLink: AssetsLink): Promise<AssetsLink> {
    const params: Record<string, string> = {
      ExpiredAt: assetsLink.ExpiredAt,
      OrganizationId: assetsLink.OrganizationId,
    }
    if (assetsLink.Id) params.Id = assetsLink.Id
    if (assetsLink.CreatedBy) params.CreatedBy = assetsLink.CreatedBy
    if (assetsLink.UrlAddr) params.UrlAddr = assetsLink.UrlAddr

    const raw = await this.http.post<AssetsLinkResponseDto>('assets', {
      searchParams: new URLSearchParams(params),
    })
    return toDomain(raw)
  }

  async findById(id: string): Promise<AssetsLink> {
    const raw = await this.http.get<AssetsLinkResponseDto>(`assets/${id}`)
    return toDomain(raw)
  }
}
